import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-wealth-report/jb-wealth-report.scss?inline
var jb_wealth_report_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.title {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.title {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.375rem;
  letter-spacing: calc(var(--letter-spacing-factor, 3) * 0.063rem);
  line-height: 2.25rem;
}
@media (min-width: 1281px) {
  .title {
    font-size: 1.75rem;
    letter-spacing: calc(var(--letter-spacing-factor, 4) * 0.063rem);
    line-height: 2.5rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

.title {
  display: block;
  margin-bottom: 68px;
  text-align: center;
  text-transform: uppercase;
}

jb-wealth-report-globe {
  margin-bottom: 8px;
}
@media (min-width: 960px) {
  jb-wealth-report-globe {
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
    justify-self: flex-end;
    margin-bottom: 0;
  }
}

jb-wealth-report-list {
  margin-top: 28px;
}
@media (min-width: 960px) {
  jb-wealth-report-list {
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
    margin-top: 0;
    padding-block: 25px;
  }
}

@media (min-width: 960px) {
  .world_wealth_report {
    display: grid;
    gap: 50px;
    grid-template: none/1fr 1fr;
  }
  jb-wealth-report-stats {
    grid-column: 1/3;
    grid-row: 2/3;
    margin: 0 auto;
    box-sizing: border-box;
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    padding: 0 20px;
    width: 83.3333333333%;
  }
  jb-wealth-report-list {
    align-self: center;
  }
}`;

// src/components/jb-wealth-report/jb-wealth-report.ts
var JbWealthReport = class extends Spaceable(h) {
  constructor() {
    super(...arguments);
    this._wealthList = [];
    this._wealthStatExtremes = {};
    this._wealthStats = {};
  }
  firstUpdated() {
    this._makeWealthList();
    this._makeWealthStats();
    this._makeWealthStatExtremes();
  }
  _citySelected(event) {
    this.selectedCity = event.detail.cityKey;
    this._makeWealthStats();
  }
  _getContentSpacingProperties() {
    return { colsMdUp: "none", horizontal: "full-width-sm-down" };
  }
  _makeWealthList() {
    Object.entries(this.cities).forEach(([key, city]) => {
      this._wealthList.push({
        cityKey: key,
        city: city.name,
        rank21: city.rank21,
        rank22: city.rank22
      });
    });
  }
  _makeWealthStatExtremes() {
    Object.values(this.cities).forEach((city) => {
      Object.keys(city.stats).forEach((statKey) => {
        if (!this._wealthStatExtremes[statKey]) {
          this._wealthStatExtremes[statKey] = { high: 0, low: 10 };
        }
        this._wealthStatExtremes[statKey].high = Math.max(this._wealthStatExtremes[statKey].high, city.stats[statKey]);
        if (city.stats[statKey] > 0) {
          this._wealthStatExtremes[statKey].low = Math.min(this._wealthStatExtremes[statKey].low, city.stats[statKey]);
        }
      });
    });
  }
  _makeWealthStats() {
    const currentCity = this.cities[this.selectedCity];
    Object.keys(currentCity.stats).forEach((key) => {
      this._wealthStats[key] = {
        label: this.translations[key],
        stat: currentCity.stats[key]
      };
    });
  }
  render() {
    return ke`
      <div class="title">${this.headLine}</div>
      <div
        class="world_wealth_report"
        @jb-wealth-report:city-selected=${this._citySelected}
      >
        <jb-wealth-report-globe
          .cities=${this.cities}
          .selectedCity=${this.selectedCity}
          .region=${this.cities[this.selectedCity].region}
        ></jb-wealth-report-globe>
        <jb-wealth-report-stats
          .cityName=${this.cities[this.selectedCity].name}
          .stats=${this._wealthStats}
          .statsExtremes=${this._wealthStatExtremes}
        ></jb-wealth-report-stats>
        <jb-wealth-report-list
          .alphabetical=${this.translations.alphabetical}
          .globalRanking=${this.translations.globalRanking}
          .change=${this.translations.change}
          .list=${this._wealthList}
          .selectedCity=${this.selectedCity}
        ></jb-wealth-report-list>
      </div>
    `;
  }
};
JbWealthReport.styles = r(jb_wealth_report_default);
__decorateClass([
  n({ type: Array })
], JbWealthReport.prototype, "cities", 2);
__decorateClass([
  n()
], JbWealthReport.prototype, "headLine", 2);
__decorateClass([
  n()
], JbWealthReport.prototype, "selectedCity", 2);
__decorateClass([
  n({ type: Object })
], JbWealthReport.prototype, "translations", 2);
JbWealthReport = __decorateClass([
  customElement("jb-wealth-report")
], JbWealthReport);

export {
  JbWealthReport
};
